import { useLayoutEffect, useState } from 'react';
type Size = {
  width: number;
  height: number;
};

/** ドキュメントのサイズ（幅と高さ）を追跡するカスタムフック */
export default function useDocumentSize() {
  const html = document.documentElement;
  const [windowSize, setWindowSize] = useState<Size>({
    width: html.clientWidth,
    height: html.clientHeight
  });
  useLayoutEffect(() => {
    function handleResize() {
      setWindowSize({
        width: html.clientWidth,
        height: html.clientHeight
      });
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [html]);
  return windowSize;
}